import { API_BASE_URL } from '../config';
// src/pages/Inventory.jsx
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import InventoryDashboard from '../components/InventoryDashboard';
import PurchaseManagement from '../components/PurchaseManagement';
import Modal from '../components/common/Modal';
import ProductForm from '../components/ProductForm';

const Inventory = ({ currentUser }) => {
    const [products, setProducts] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showPurchaseModal, setShowPurchaseModal] = useState(false);
    const [showNewProductModal, setShowNewProductModal] = useState(false);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const productsResponse = await axios.get(`${API_BASE_URL}/server/api/products.php`);
            const suppliersResponse = await axios.get(`${API_BASE_URL}/server/api/suppliers.php`);
            setProducts(productsResponse.data);
            setSuppliers(suppliersResponse.data);
            setLoading(false);
        } catch (err) {
            console.error('Failed to fetch data:', err);
            setError('Failed to fetch products or suppliers. Please check the backend server.');
            setLoading(false);
        }
    };

    if (loading) return <div className="text-center p-4">Loading...</div>;
    if (error) return <div className="text-center p-4 text-red-600">{error}</div>;

    return (
        <div className="w-full pb-20 md:pb-6">
            <InventoryDashboard
                onRecordPurchase={() => setShowPurchaseModal(true)}
                products={products}
                suppliers={suppliers}
                onDataChange={fetchData}
                onAddProduct={() => setShowNewProductModal(true)}
            />

            {showPurchaseModal && (
                <PurchaseManagement
                    products={products}
                    suppliers={suppliers}
                    onPurchaseComplete={() => {
                        fetchData();
                        setShowPurchaseModal(false);
                    }}
                    onClose={() => setShowPurchaseModal(false)}
                />
            )}

            {showNewProductModal && (
                <Modal onClose={() => setShowNewProductModal(false)}>
                    <ProductForm
                        onProductAdded={() => {
                            setShowNewProductModal(false);
                            fetchData();
                        }}
                        initialData={null}
                    />
                </Modal>
            )}
        </div>
    );
};

export default Inventory;